


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { styleKey, StyleElement, PageKey } from '../keyFactory';
import { FontField, ColorField, FontSizeField, AlignField } from '../controls';

type StyleKV = Record<string, string>;

/**
 * 文本样式四联组（字体/颜色/字号/对齐）。
 * key 解析只能走 keyFactory.styleKey；调用方不得在本组件外拼接 __middleN/-end。
 * 对齐的显示时机（triggerEventType===7 / privacy 恒有）由调用方经 fields.align 控制，
 * 组件本身不感知 triggerEventType。
 */
@Component({ components: { FontField, ColorField, FontSizeField, AlignField } })
export default class PopTextStyleGroup extends Vue {
  @Prop({ type: Object, required: true }) styleMap!: Record<string, StyleKV>;
  @Prop({ type: String, required: true }) element!: StyleElement;
  @Prop({ type: String, default: 'start' }) page!: PageKey;
  @Prop({ type: Object, default: () => ({}) }) fields!: Record<string, boolean>;
  @Prop({ type: String, default: 'picker' }) fontControl!: 'picker' | 'select';
  @Prop({ type: Boolean, default: false }) showAddButton!: boolean;
  @Prop({ type: String, default: 'normal' }) sizeTier!: 'normal' | 'small';
  @Prop({ type: String, default: '10' }) col!: string;
  /** 逐字段 col 覆盖（如新版主标题字体行整行宽无 col：:cols="{ font: '' }"），未覆盖的字段用 col */
  @Prop({ type: Object, default: () => ({}) }) cols!: Record<string, string>;
  @Prop({ type: Object, default: () => ({}) }) labels!: Record<string, string>;

  colOf(field: string): string {
    return this.cols[field] !== undefined ? this.cols[field] : this.col;
  }

  get groupKey(): string {
    return styleKey(this.element, this.page);
  }
  get show() {
    return {
      font: this.fields.font !== false,
      color: this.fields.color !== false,
      size: this.fields.size !== false,
      align: this.fields.align === true,
    };
  }
  get text() {
    return {
      font: this.labels.font || '字体',
      color: this.labels.color || '文字颜色',
      size: this.labels.size || '字体大小',
      align: this.labels.align || '文本对齐',
    };
  }
  get(prop: string): string {
    const row = this.styleMap[this.groupKey];
    return (row && row[prop]) || '';
  }
  set(prop: string, v: string) {
    if (!this.styleMap[this.groupKey]) {
      this.$set(this.styleMap, this.groupKey, {});
    }
    this.$set(this.styleMap[this.groupKey], prop, v);
  }
  emitChange() {
    this.$emit('change');
  }
}
